import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const JourneyBarGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space['space-100']};
  width: 100%;
`;
